module.exports = __webpack_public_path__ + "components/outside-promo-page/static/surfers-cc6b0a911ee946ea93e1ab851b4a1fe4.webp";